import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const PreviewImageContainer: StyleRule = () => ({
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
});

export const Loading: StyleRule = ({ theme }) => ({
    background: `rgba(255, 255, 255, 0.3)`,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [`& .${svgIconClassName}`]: {
        fill: theme.siteVariables.colors.charcoal[100],
        zoom: 2,
    },
});
